import { useContext } from "react"
import { AtribuirBairrosContext } from "./AtribuirBairrosContext"

export function useAtribuirBairrosContext() {
    return useContext(AtribuirBairrosContext)
}
